/**
 * Investment member services workflow (docs/Decisions.md D66). Mirror of the
 * API's src/services/billing/memberServiceRules.js; memberServices.test.js
 * imports both to prove they agree. The labels live only here.
 */

export const FEE_LIMITS = Object.freeze({ minCents: 100, maxCents: 5_000_000 });

export const SERVICE_ID_RE = /^(?!requests$)[a-z0-9][a-z0-9-]{1,48}[a-z0-9]$/;

export const STATUSES = [
  'pending_approval',
  'approved',
  'in_progress',
  'completed',
  'declined',
  'cancelled',
];

export const OPEN_STATUSES = ['pending_approval', 'approved', 'in_progress'];

export const ACTIONS = Object.freeze({
  approve: { by: ['orgAdmin'], from: ['pending_approval'], to: 'approved' },
  decline: {
    by: ['orgAdmin', 'platform'],
    from: ['pending_approval', 'approved', 'in_progress'],
    to: 'declined',
    noteRequired: true,
  },
  cancel: { by: ['member', 'orgAdmin'], from: ['pending_approval', 'approved'], to: 'cancelled' },
  start: { by: ['platform'], from: ['approved'], to: 'in_progress' },
  complete: { by: ['platform'], from: ['approved', 'in_progress'], to: 'completed' },
});

export function allowedActions(status, roles) {
  return Object.entries(ACTIONS)
    .filter(([, a]) => a.from.includes(status) && a.by.some(r => roles.includes(r)))
    .map(([name]) => name);
}

export function isOffered(service) {
  return Boolean(service?.active && Number.isInteger(service.feeCents) && service.feeCents > 0);
}

export const STATUS_LABELS = {
  pending_approval: 'Waiting for org approval',
  approved: 'Approved, waiting for the platform',
  in_progress: 'In progress',
  completed: 'Completed',
  declined: 'Declined',
  cancelled: 'Cancelled',
};

export const STATUS_TONE = {
  pending_approval: 'warning',
  approved: 'info',
  in_progress: 'info',
  completed: 'success',
  declined: 'danger',
  cancelled: 'neutral',
};

export const ACTION_LABELS = {
  approve: 'Approve',
  decline: 'Decline',
  cancel: 'Cancel request',
  start: 'Start work',
  complete: 'Mark complete and charge',
};

/** Whole dollars and cents for a fee input, and back. */
export function centsToInput(cents) {
  return Number.isInteger(cents) ? (cents / 100).toFixed(2) : '';
}

export function inputToCents(text) {
  const trimmed = String(text ?? '').trim();
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) return NaN;
  return Math.round(Number(trimmed) * 100);
}
